import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Device, ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UnenrolledDeviceResolverActions = createActionGroup({
  source: 'Unenrolled Device Resolver',
  events: {
    'Unenrolled Devices requested': emptyProps(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UnenrolledDeviceViewActions = createActionGroup({
  source: 'Unenrolled Device View',
  events: {
    'Unenrolled Devices delete requested': props<{ unenrolledDeviceIds: string[] }>(),
    'Unenrolled Devices deleted': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const UnenrolledDeviceApiActions = createActionGroup({
  source: 'Unenrolled Device API',
  events: {
    'Unenrolled Devices loaded': props<{ unenrolledDevices: Device[] }>(),
    'Unenrolled Devices loaded error': props<{ error: ErrorModel }>(),
    'Unenrolled Devices deleted error': props<{ error: ErrorModel }>(),
  },
});
